import { Outlet } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import { useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";

function Layout() {

  /************START УСТАНОВКА Cookie для промо кода**************************/
  const [searchParams, setSearchParams] = useSearchParams();
  const promo = searchParams.get("promo");

  const [cookies, setCookie, removeCookie] = useCookies(['biz_promo']);
  if (promo !== null) {
    setCookie('biz_promo', promo, { path: '/', /*domain: '.user-office.ru',*/ maxAge: 604800, secure: true })//На 7 дней
  }
  /************START УСТАНОВКА Cookie для промо кода**************************/


  return (
    <>
      <Outlet></Outlet>
    </>
  );
}

export default Layout;
